export { default } from './Messages';



// WEBPACK FOOTER //
// ./src/client/js/view/components/FlashMessages/Messages/index.js